import { Image, Video, Mic, FileIcon, MapPin, Contact2, BarChart3 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ReplyPreviewProps {
  replyToMessage: {
    id: number;
    text?: string | null;
    fromName?: string | null;
    media?: { type?: string } | null;
  };
  isOutgoing?: boolean;
  className?: string;
  onClick?: () => void;
}

/**
 * Компонент для отображения превью сообщения, на которое ответили
 */
export function ReplyPreview({ replyToMessage, isOutgoing, className, onClick }: ReplyPreviewProps) {
  const mediaType = replyToMessage.media?.type;

  // Get media icon and label
  const getMediaInfo = () => {
    switch (mediaType) {
      case 'photo':
        return { icon: Image, label: 'Фото' };
      case 'video':
        return { icon: Video, label: 'Видео' };
      case 'voice':
        return { icon: Mic, label: 'Голосовое сообщение' };
      case 'video_note':
        return { icon: Video, label: 'Видеосообщение' };
      case 'audio':
        return { icon: Mic, label: 'Аудио' };
      case 'document':
        return { icon: FileIcon, label: 'Документ' };
      case 'sticker':
        return { icon: null, label: 'Стикер' };
      case 'location':
        return { icon: MapPin, label: 'Геопозиция' };
      case 'venue':
        return { icon: MapPin, label: 'Место' };
      case 'contact':
        return { icon: Contact2, label: 'Контакт' };
      case 'poll':
        return { icon: BarChart3, label: 'Опрос' };
      default:
        return null;
    }
  };

  const mediaInfo = getMediaInfo();
  const displayText = replyToMessage.text || (mediaInfo ? mediaInfo.label : '');

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
      className={cn(
        'flex items-stretch gap-2 mb-1 cursor-pointer rounded overflow-hidden',
        isOutgoing ? 'hover:bg-white/10' : 'hover:bg-muted',
        className
      )}
    >
      {/* Left border accent */}
      <div
        className={cn(
          'w-0.5 flex-shrink-0 rounded-full',
          isOutgoing ? 'bg-white/50' : 'bg-primary'
        )}
      />

      {/* Content */}
      <div className="flex-1 min-w-0 py-0.5">
        {/* Sender name */}
        {replyToMessage.fromName && (
          <p
            className={cn(
              'text-xs font-medium truncate',
              isOutgoing ? 'text-white/90' : 'text-primary'
            )}
          >
            {replyToMessage.fromName}
          </p>
        )}

        {/* Message preview */}
        <div className="flex items-center gap-1.5">
          {mediaInfo?.icon && (
            <mediaInfo.icon
              className={cn(
                'h-3 w-3 flex-shrink-0',
                isOutgoing ? 'text-white/70' : 'text-muted-foreground'
              )}
            />
          )}
          <p
            className={cn(
              'text-xs truncate',
              isOutgoing ? 'text-white/70' : 'text-muted-foreground'
            )}
          >
            {displayText || 'Сообщение'}
          </p>
        </div>
      </div>
    </div>
  );
}
